import { useEffect, useState } from "react";
import useGetItems from "../../../hooks/_REST API/GET/use-get-items";
import styles from "./ItemList.module.css";
import ShowItem from "./ShowItem";
import { useInView } from "react-intersection-observer";
import { Outlet } from "react-router";

const loadingArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export default function ItemList({ filters = "", dataCtx, setItemCount }) {
  const [items, getItems, reqSent] = useGetItems();
  const [productCounter, setProductCounter] = useState(50);
  const [loaderTrigger, setLoaderTrigger] = useState(true);
  const { ref, inView } = useInView(1);

  useEffect(() => {
    setProductCounter(50);
    getItems(filters);
  }, [filters]);

  useEffect(() => {
    if (items === -1 || items - 2) {
      setItemCount(0);
    } else {
      setItemCount(items.length);
    }
  }, [items]);

  useEffect(() => {
    if (inView) {
      setLoaderTrigger(false);
      getItems(filters, productCounter, setProductCounter);
    }
  }, [inView]);

  useEffect(() => {
    setLoaderTrigger(true);
  }, [productCounter]);

  return (
    <main className={styles.main}>
      <Outlet />

      {items !== -1 && items !== -2 ? (
        <div className={styles.list}>
          {items.length > 0 && (
            <>
              {items.map((item, key) => {
                return <ShowItem key={key} item={item} />;
              })}
            </>
          )}
          {reqSent && (
            <>
              {loadingArray.map((i, k) => {
                return <div key={k} className={styles.loader} />;
              })}
            </>
          )}
        </div>
      ) : (
        <div className={styles[`no-exist`]}>
          {items === -2 ? (
            <>
              {dataCtx?.pageData?.market?.error_req ||
                "Pogreška! Pokušajte ponovo učitati stranicu."}
            </>
          ) : (
            <>
              {dataCtx?.pageData?.market?.error_no_items ||
                "Trenutno nema proizvoda za ovu kategoriju."}
            </>
          )}
        </div>
      )}
      {items.length >= productCounter && loaderTrigger && (
        <div ref={ref} className={styles[`load-more-trigger`]} />
      )}
    </main>
  );
}
